export interface IGateStatus {
  gate: string;
  gateStatus: string;
  action: string,
  inTraffic: boolean,
  date: Date;
}


export class GateStatus implements IGateStatus {

  public gate: string;
  public gateStatus: string;
  public action: string;
  public inTraffic: boolean;
  public date: Date;

  public constructor(gate: string, status: string) {
    this.gate = gate;
    this.gateStatus = status;
  }
}

export enum BusTransferActionEnum {
  Unknown = 0,
  Request = 1,
  Cancel = 2,
  Update = 3,
  Arrived = 4,
  Left = 5,
  Created = 6,
  Started = 7
}

export enum GateStatusEnum {
  Open = 1,
  Pause = 2,
  Close = 3
}
